module.exports = __webpack_public_path__ + "img/elitefit-ai-logo-white-bg.47c240be.png";